import { useEffect } from "react";
import Faq from "@/components/sections/Faq";

export default function FaqPage() {
  useEffect(() => { document.title = "FAQ — Warranty_Vault pro"; }, []);
  return (
    <main className="pt-16" data-testid="faq-page">
      <Faq />
    </main>
  );
}
